export const ARIA_LINK_MODES = ['aria-describedby', 'aria-labelledby'] as const;

/**
 * Arrow size (in pixel).
 */
export const ARROW_SIZE = 8;

/**
 * Make sure tooltip appear above popovers.
 * Hardcoded as POPOVER_ZINDEX (9999) + 1.
 */
export const TOOLTIP_ZINDEX = 10000;
